/* LABEL R S — Wishlist v10
   Injects heart buttons. Hides Horizon’s native save button via JS (not CSS element name). */
(function () {
  'use strict';
  var KEY = 'lrs_wl_v3';

  function getStore() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function saveStore(s) { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }
  function has(h) { return !!getStore()[h]; }
  function count() { return Object.keys(getStore()).length; }
  function toggle(data) {
    var s = getStore(), h = typeof data === 'string' ? data : data.handle;
    if (s[h]) { delete s[h]; saveStore(s); return false; }
    s[h] = typeof data === 'object' && data.title ? data : { handle: h };
    saveStore(s); return true;
  }

  function syncCount() {
    var n = count();
    document.querySelectorAll('[data-wl-count], .lrs-wl-nav-badge').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      el.style.display = n > 0 ? 'flex' : 'none';
    });
  }

  function syncBtnVisual(btn, handle) {
    var saved = has(handle);
    var svg = btn.querySelector('svg');
    if (svg) {
      svg.setAttribute('fill', saved ? '#C5A45E' : 'none');
      svg.setAttribute('stroke', saved ? '#C5A45E' : '#5C3349');
    }
    btn.setAttribute('aria-pressed', String(saved));
    btn.title = saved ? 'Remove from Wishlist' : 'Add to Wishlist';
  }

  function extractData(link, handle) {
    var card = link.closest('.product-card, product-card, .resource-card') || link.parentElement;
    var titleEl = card ? card.querySelector('[class*="product-title"],[class*="card__title"],[class*="product-name"],h2,h3') : null;
    var title = (titleEl ? titleEl.textContent.trim() : '') || handle.replace(/-/g, ' ');
    var priceEl = card ? card.querySelector('[class*="price__regular"],[class*="price__sale"],[class*="price"]:not([class*="compare"]):not([class*="was"]):not(s):not(del)') : null;
    var price = priceEl ? priceEl.textContent.trim().replace(/\s+/g, ' ').split('\n')[0] : '';
    if (price.length > 25) price = price.substring(0, 25);
    var imgEl = link.querySelector('img');
    var img = imgEl ? (imgEl.currentSrc || imgEl.getAttribute('src') || '') : '';
    if (img && img.indexOf('cdn.shopify.com') !== -1) img = img.replace(/(_\d+x\d*)?(\.[^.?]+)(\?.*)?$/, '_400x$2');
    return { handle: handle, title: title, price: price, img: img };
  }

  /* Inject toast style once */
  (function () {
    if (document.getElementById('lrs-wl-ts')) return;
    var s = document.createElement('style'); s.id = 'lrs-wl-ts';
    s.textContent =
      '#lrs-wl-toast{position:fixed;bottom:90px;left:50%;transform:translateX(-50%) translateY(6px);' +
      'background:#3D2532;color:#f5e6d4;padding:10px 22px;border-radius:999px;font-size:0.85rem;' +
      'font-weight:500;letter-spacing:0.04em;box-shadow:0 4px 20px -6px rgba(42,27,34,.6);' +
      'z-index:999999;opacity:0;transition:opacity .28s,transform .28s;pointer-events:none;white-space:nowrap;}' +
      '#lrs-wl-toast.show{opacity:1;transform:translateX(-50%) translateY(0)}';
    document.head.appendChild(s);
  })();

  var _tt;
  function toast(msg) {
    var el = document.getElementById('lrs-wl-toast');
    if (!el) { el = document.createElement('div'); el.id = 'lrs-wl-toast'; document.body.appendChild(el); }
    el.textContent = msg; el.classList.add('show');
    clearTimeout(_tt); _tt = setTimeout(function () { el.classList.remove('show'); }, 2600);
  }

  /* Create heart button */
  function createHeartBtn(handle, link) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lrs-wl-heart';
    btn.setAttribute('data-lrs-handle', handle);
    btn.setAttribute('aria-label', 'Save to Wishlist');
    btn.style.cssText =
      'position:absolute;top:10px;right:10px;z-index:50;' +
      'width:36px;height:36px;border-radius:50%;' +
      'background:rgba(255,255,255,0.92);border:none;' +
      'display:flex;align-items:center;justify-content:center;' +
      'cursor:pointer;box-shadow:0 2px 10px rgba(0,0,0,0.18);padding:0;' +
      '-webkit-tap-highlight-color:transparent;touch-action:manipulation;';
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#5C3349" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>' +
      '</svg>';
    syncBtnVisual(btn, handle);
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var data = extractData(link, handle);
      var added = toggle(data);
      syncBtnVisual(btn, handle);
      syncCount();
      document.querySelectorAll('[data-lrs-handle="' + handle + '"]').forEach(function (b) { syncBtnVisual(b, handle); });
      toast(added ? '\u2665 Saved to Wishlist' : 'Removed from Wishlist');
    });
    return btn;
  }

  /* Hide Horizon’s native save button inside the given card.
     Logic: any button that is NOT my heart, NOT a cart/add/nav button, with short/no text = native save btn */
  function hideNativeSaveBtn(card) {
    card.querySelectorAll('button:not(.lrs-wl-heart)').forEach(function (btn) {
      var label = (btn.getAttribute('aria-label') || btn.getAttribute('title') || '').toLowerCase();
      var cls   = (btn.className || '').toLowerCase();
      var text  = btn.textContent.trim().toLowerCase();
      /* Keep: cart, add, buy, quick-add, navigation arrows */
      var isKeep = /add to cart|quick.?add|add to bag|buy now|next|prev(ious)?|arrow|close|search|share|zoom/i.test(label)
                 || /quick.?add|add.?cart|cart.?btn|buy.?btn|nav|arrow|next|prev/i.test(cls)
                 || /add to cart|buy now|add to bag/i.test(text)
                 || text.length > 15;
      if (!isKeep) {
        btn.style.setProperty('display', 'none', 'important');
        btn.style.setProperty('visibility', 'hidden', 'important');
        btn.style.setProperty('pointer-events', 'none', 'important');
      }
    });
  }

  /* Inject heart buttons into all product image links */
  var DONE_ATTR = 'data-lrs-wl-done';
  function injectHearts(root) {
    root = root || document;
    root.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      if (link.getAttribute(DONE_ATTR)) return;
      if (!link.querySelector('img, picture')) return;
      var m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!m || /^\d+$/.test(m[1])) return;
      var handle = m[1];
      link.setAttribute(DONE_ATTR, '1');
      if (!link.style.position || link.style.position === 'static') link.style.position = 'relative';
      link.appendChild(createHeartBtn(handle, link));
      /* Hide native save button(s) in parent card */
      var card = link.closest('.product-card, product-card, [class*="product-card"], .resource-card') || link.parentElement;
      if (card) hideNativeSaveBtn(card);
    });
  }

  /* MutationObserver for lazy-loaded content */
  function watchMutations() {
    if (!window.MutationObserver) return;
    var timer;
    new MutationObserver(function (mutations) {
      if (mutations.some(function (m) { return m.addedNodes.length > 0; }))
        { clearTimeout(timer); timer = setTimeout(injectHearts, 200); }
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* Wishlist page: remove item */
  document.addEventListener('click', function (e) {
    try {
      var btn = e.target.closest('[data-wl-remove]'); if (!btn) return;
      var h = btn.getAttribute('data-wl-remove');
      var s = getStore(); delete s[h]; saveStore(s); syncCount();
      var card = btn.closest('.lrs-wl-card'); if (card) card.remove();
      var grid = document.getElementById('lrs-wl-grid');
      if (grid) {
        var left = grid.querySelectorAll('.lrs-wl-card').length;
        var c = document.getElementById('lrs-wl-pg-count');
        if (c) c.textContent = left ? '(' + left + ' item' + (left > 1 ? 's' : '') + ')' : '';
        if (!left) {
          grid.style.display = 'none';
          var empty = document.getElementById('lrs-wl-empty'); if (empty) empty.style.display = '';
          var clr = document.getElementById('lrs-wl-clear-all'); if (clr) clr.style.display = 'none';
        }
      }
    } catch (err) {}
  });

  function init() {
    syncCount(); injectHearts();
    setTimeout(injectHearts, 400);
    setTimeout(injectHearts, 1500);
    setTimeout(injectHearts, 3500);
    watchMutations();
  }

  window.LrsWL = { getStore: getStore, has: has, toggle: toggle, count: count, init: init, inject: injectHearts, syncCount: syncCount };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
